import { render } from "./NewsListItem.vue?vue&type=template&id=b3249e4a&scoped=true"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"

import "./NewsListItem.vue?vue&type=style&index=0&id=b3249e4a&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3249e4a"]])

export default __exports__